import React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { Spinner } from '@change/ds-core-ui/Spinner';
import { Text } from '@change/ds-core-ui/Text';
import { ArrowRightIcon } from '@change/ds-icons/ArrowRightIcon';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { PromptInput, PromptInputActions, PromptInputTextarea } from '../PromptInput';

import { useSapIssueForm } from './hooks/useSapIssueForm';

export const SapIssueForm: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();
	const {
		data: { isSubmitting },
		actions: { onSubmit },
	} = useSapIssueForm();

	const imageButtonIcon = isSubmitting ? <Spinner className="size-4" /> : <ArrowRightIcon />;
	const ariaLabel = isSubmitting
		? translate('corgi.homepage.hero_section.input_prompt_submit_button_loading')
		: translate('corgi.homepage.hero_section.input_prompt_submit_button');

	return (
		<div className="mb-3 flex w-full flex-col items-center justify-center lg:mb-3">
			<div className="flex w-full max-w-[600px] flex-col gap-4">
				<div>
					<Text className="text-center" variant="body" size="large" fontWeight="bold" as="h2" id="sap-input-heading">
						<Translate value="corgi.homepage.hero_section.input_prompt_label_alt" />
					</Text>
				</div>
				<form onSubmit={onSubmit} data-qa="sap-input-prompt-form">
					<PromptInput data-qa="sap-prompt" className="group">
						<PromptInputTextarea
							maxLength={500}
							name="issue"
							placeholder={translate('corgi.homepage.hero_section.input_prompt_placeholder')}
							aria-labelledby="sap-input-heading"
							enterKeyHint="send"
						/>

						<PromptInputActions data-qa="prompt-input-actions">
							<Button
								aria-label={ariaLabel}
								aria-live="polite"
								className="bg-fill-interactive ml-auto h-11 w-11 rounded-full"
								iconOnly
								leadingIcon={imageButtonIcon}
								variant="primary"
								type="submit"
								data-qa="prompt-input-actions-button"
							/>
						</PromptInputActions>
					</PromptInput>
				</form>
			</div>
		</div>
	);
};
